<div class="map-search-container container"
     [class.expanded]="isSpotlightExpanded"
     fxFill>
  <mtn-map [options]="options" (ready)="onMapReady($event)" *ngIf="options"></mtn-map>

  <!-- Warning Banner -->
  <div class="mtn-data-zoom-warning" fxLayout="row" fxLayoutAlign="center center"
       *ngIf="map && isFeatureLayerEnabled && map.getZoom() <= 7">
    <div class="warning-container" fxLayout="row" fxLayoutGap="5px">
      <fa-icon icon="exclamation-triangle"></fa-icon>
      <strong class="color-primary">{{'ZOOM_IN_TO_LOAD_INSIGHTS_DATA' | translate}}</strong>
    </div>
  </div>

  <!-- Spotlight Panel -->
  <mtn-store-spotlight-panel
    #storeSpotlightPanel
    [map]="map"
    (expandRequested)="handleExpand()"
    *ngIf="map?.selections.size === 1"  [class.analytics-active]="isAnalyticsSpotlightOpen" [class.expanded-view]="isSpotlightExpanded"
  (analyticsActiveChange)="onAnalyticsActiveChange($event)">
  </mtn-store-spotlight-panel>

  <mtn-multi-select-spotlight-panel
    [map]="map"
    *ngIf="map?.selections.size > 1">
  </mtn-multi-select-spotlight-panel>
</div>
